// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let BrokerMessage = function (fieldSet)
{
    this.Code = Message.CODE_TEXT_MESSAGE
    PFixMessage.call(this, fieldSet)
}
BrokerMessage.prototype = Object.create(PFixMessage.prototype)

BrokerMessage.prototype.setText = function (text)
{
    this.setFieldValue(FieldsFactory.FIELD_TEXT, text)
}
BrokerMessage.prototype.setType = function (type)
{
    this.setFieldValue(FieldsFactory.FIELD_TEXT_MESSGE_TYPE, type);
}
BrokerMessage.prototype.setSenderId = function (id)
{
    this.setFieldValue(FieldsFactory.FIELD_SENDER_ID, id);
}
BrokerMessage.prototype.setTargetId = function (id)
{
    this.setFieldValue(FieldsFactory.FIELD_TARGET_ID, id);
}
BrokerMessage.prototype.setDate = function (date)
{
    this.setFieldValue(FieldsFactory.FIELD_DATE, date);
}
BrokerMessage.prototype.setName = function (name)
{
    this.setFieldValue(FieldsFactory.FIELD_NAME, name);
}
BrokerMessage.prototype.setId = function (id)
{
    this.setFieldValue(FieldsFactory.FIELD_ID, id);
}